import React, { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  FlatList,
  Platform
} from 'react-native';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import TopGreenHeader from '../Common/TopGreenHeader';
import { getAllKidsCreator, resetCreateKidSuccessCreator } from '../../slices/authSlice';
import { toast } from 'react-toastify';
import ChildDetails from '../../ChildDetails';

const SelectKidScreen1 = ({ route }) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const getAllkids = useSelector(state => state.auth.getAllkids);
  const planChoosed = useSelector(state => state.auth.planChoosed);
  const serviceScheduled = useSelector(state => state.auth.serviceScheduled);
  const [allKidsData, setAllKidsData] = useState([]);
  const [kidData, setKidData] = useState(null);
  const [visible, setVisible] = useState(false);
 const { numOfKids } = planChoosed || {};
const { serviceName } = serviceScheduled || {};
  const [selectedKidsId, setSelectedKidsId] = useState([]);
  const [kidsSelected, setKidsSelected] = useState([]);

  useFocusEffect(
    useCallback(() => {
      dispatch(getAllKidsCreator());
      dispatch(resetCreateKidSuccessCreator());
    }, [dispatch])
  );

  useEffect(() => {
    setAllKidsData(getAllkids?.Data?.kids || []);
  }, [getAllkids]);

  const toggleKidSelection = (item, id) => {
    if (selectedKidsId.includes(id)) {
      setSelectedKidsId(selectedKidsId.filter(kidId => kidId !== id));
      setKidsSelected(kidsSelected.filter(kid => kid.id !== id));
    } else if (selectedKidsId.length >= numOfKids) {
      toast.info(`Please select ${numOfKids} kid(s), as per plan you selected`);
    } else {
      setSelectedKidsId([...selectedKidsId, id]);
      setKidsSelected([...kidsSelected, item]);
    }
  };

  const renderKidItem = ({ item }) => (
    <TouchableOpacity
      style={styles.kidItem}
      onPress={() => { setKidData(item); setVisible(true); }}
    >
      <Image
        source={item.profilePic ? { uri: item.profilePic } : require('../../assets/AddKidPic.png')}
        style={styles.kidImage}
      />
      <View style={styles.kidInfo}>
        <Text style={styles.kidName}>{item.name}</Text>
        <Text style={styles.kidDetails}>
          {`${item.age} years, ${item.gender === 'BOY' ? 'Male' : 'Female'}`}
        </Text>
      </View>
    </TouchableOpacity>
  );

  return (
    <>
      <ChildDetails
        kid={kidData}
        visible={visible}
        setVisible={setVisible}
        onUpdateSuccess={() => dispatch(getAllKidsCreator())}  // refreshes list after edit
      />
      <TopGreenHeader
        Heading={'Kid(s)'}
        navigation={navigation}
        isBackIcon={true}
        isNotification={false}
      />
      <View style={styles.container}>
        <FlatList
          data={allKidsData}
          renderItem={renderKidItem}
          keyExtractor={item => item.id.toString()}
          contentContainerStyle={styles.listContainer}
        />
        <View style={styles.buttonContainer}>
          <TouchableOpacity
            style={styles.addButton}
            onPress={() => navigation.navigate('AddNewKidScreen')}
          >
            <Text style={styles.addButtonText}>Add New Kid</Text>
          </TouchableOpacity>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    padding: 16,
  },
  listContainer: {
    paddingBottom: 16,
  },
  kidItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    marginBottom: 8,
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
    justifyContent: 'space-between',
  },
  kidImage: {
    width: 50,
    height: 50,
    borderRadius: 25,
    marginRight: 12,
  },
  kidInfo: {
    flex: 1,
  },
  kidName: {
    fontSize: 18,
    color: '#000',
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
  },
  kidDetails: {
    fontSize: 12,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    color: '#666',
  },
  buttonContainer: {
    alignItems: 'center',
    marginTop: 16,
  },
  addButton: {
    backgroundColor: '#A3D900',
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    width: '60%',
    marginBottom: 12,
  },
  addButtonText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#fff',
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
});

export default SelectKidScreen1;